import { useRouter } from '@tanstack/react-router';
import Iconify from '@emfood/shared/src/components/iconify';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { GoBackHeaderProps } from './types';

export default function GoBackHeader({
  action,
  heading,
  subHeading,
  moreLink,
  sx,
  disableGoBack = false,
}: GoBackHeaderProps) {
  const { history } = useRouter();

  return (
    <Box sx={[{ mb: { xs: 3, md: 5 } }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {/* `action` sits to the right of the heading and wraps below it on narrow viewports. */}
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2}>
        <Box sx={{ flexGrow: 1, minWidth: 0, pl: 1 }}>
          {heading && (
            <Typography variant="h1" gutterBottom>
              {heading}
            </Typography>
          )}
          {subHeading && (
            <Typography variant="h2" gutterBottom>
              {subHeading}
            </Typography>
          )}

          {/* GO BACK BUTTON */}
          {!disableGoBack && (
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => history.go(-1)}
              sx={{ mt: 2 }}
              startIcon={<Iconify icon="mdi:chevron-left" />}
            >
              Back
            </Button>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0, px: { xs: 1, sm: 0 } }}>{action}</Box>}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}
